import { createApp } from 'vue';

// PRD 環境不輸出 console，避免洩漏病患資料等敏感資訊
// (esbuild.drop 設定在目前 Vite 版本改由 Rolldown 建置，不會生效，改用執行期覆寫)
if (import.meta.env.MODE === 'production') {
  const noop = () => {};
  [
    'log',
    'debug',
    'info',
    'warn',
    'error',
    'trace',
    'table',
    'group',
    'groupCollapsed',
    'groupEnd',
  ].forEach((method) => {
    console[method] = noop;
  });
}

import '@/assets/styles/tailwind.css';
import App from './App.vue';
import { createPinia } from 'pinia';
import initRouter from '@/router';
import { addPlugins } from '@/plugins/main';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import { refreshAccessToken, clearAuthData } from '@/api/config.js';
import { staffService } from '@/features/clinicSettings/api/staffService.js';
import { useAuthStore } from '@/features/auth/stores/authStore.js';

const pluginContext = {};
const pinia = createPinia();
pinia.use(
  createPersistedState({
    storage: sessionStorage,
  }),
);
const app = createApp(App);
app.use(pinia);

const { router } = initRouter();
app.use(router);

addPlugins(app, router, pluginContext);

app.component('VueDatePicker', VueDatePicker);

// 頁面重載後，嘗試用 HttpOnly refresh token cookie 靜默取得新的 access token
async function initApp() {
  if (localStorage.getItem('isLoggedIn')) {
    try {
      await refreshAccessToken();
    } catch {
      // refresh token 已過期，清除登入狀態
      clearAuthData();
    }
    // store 存在 sessionStorage，關閉分頁再開會清空，但 isLoggedIn/refresh cookie 仍在，
    // 需補打 /api/staff/me 還原登入者/預設醫師（失敗不阻擋啟動）
    const authStore = useAuthStore();
    if (authStore.accessToken && !authStore.staffName) {
      try {
        const meRes = await staffService.getMe();
        if (meRes.data?.success && meRes.data.data) {
          authStore.setStaffInfo(meRes.data.data);
        }
      } catch (e) {
        console.error('還原登入人員資料失敗:', e);
      }
    }
  }
  app.mount('#app');
}

initApp();
